<template>
    <div id="producttypeDetails">
        <div class="leftcolumn">
            <loader v-if="loading">
                {{ trans('pages.product_type_details.loading') }}
            </loader>
            <div v-else-if="productType">
                <ui5-button
                    id="producttypeDetailsBackButton"
                    @click="backToList()"
                    class="top-button"
                >
                    {{ trans('pages.product_type_details.back_to_list') }}
                </ui5-button>
                <ui5-button
                    id="editProducttype"
                    v-if="!productType.externalSystem"
                    @click="editProductType()"
                    class="top-button"
                >
                    {{ trans('pages.product_type_details.edit') }}
                </ui5-button>

                <div style="clear: both"></div>
                <div
                    class="readonly-message"
                    v-if="productType && productType.externalSystem"
                >
                    {{
                        trans(
                            'pages.product_type_details.external_system_message'
                        )
                    }}
                    <span class="account-name">
                        {{ productType.externalSystem.label }}
                    </span>
                </div>
                <div>
                    <img
                        v-if="productType"
                        class="product-type-image"
                        :src="
                            productType.imagePathCloudFront
                                ? productType.imagePathCloudFront
                                : 'images/placeholder.png'
                        "
                        @error="$event.target.src = 'images/placeholder.png'"
                    />

                    <h3>
                        {{
                            trans(
                                'pages.product_type_details.general_information'
                            )
                        }}
                    </h3>

                    <div id="producttypeDetailsGeneralInfoDiv">
                        <div
                            v-if="generalInfoItems"
                            v-for="item in generalInfoItems.filter(
                                (x) => !x.debugOnly || isDebug
                            )"
                            :key="item.label"
                            class="productpagefield"
                        >
                            <span class="productpagename">
                                {{ item.label }}
                            </span>
                            <span class="productpagevalue">
                                {{ item.value }}
                            </span>
                        </div>
                    </div>

                    <div class="descriptions-clearer"></div>

                    <h3 class="description-h3">
                        {{
                            trans(
                                'pages.product_type_details.paint_list_description'
                            )
                        }}
                    </h3>
                    <div>{{ productType.paintlistDescription }}</div>

                    <h3 class="description-h3">
                        {{
                            trans(
                                'product_types.area_calculation_formula.label'
                            )
                        }}
                    </h3>
                    <div>{{ productType.areaCalculationFormula }}</div>

                    <h3 class="description-h3">
                        {{
                            trans(
                                'product_types.paint_area_calculation_formula.label'
                            )
                        }}
                    </h3>
                    <div>{{ productType.paintAreaCalculationFormula }}</div>

                    <div
                        v-for="(title, key) in translationTitles"
                        v-if="
                            productType &&
                            productType.translations &&
                            translationTitles
                        "
                    >
                        <h3
                            class="description-h3"
                            v-if="title"
                        >
                            {{ title }}
                        </h3>
                        <translations-display
                            v-if="productType.translations[key]"
                            :translation-data="productType.translations[key]"
                        ></translations-display>
                    </div>
                </div>

                <br />
                <br />

                <h3>
                    {{ trans('pages.product_type_details.data_fields') }}
                    <i
                        class="fa fa-plus"
                        v-if="!productType.externalSystem"
                        @click="clickNewField()"
                    ></i>
                </h3>
                <table>
                    <thead>
                        <tr>
                            <th>&nbsp;</th>
                            <th>
                                {{
                                    trans('pages.product_type_details.table.id')
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.key'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.label'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.required'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.datatype'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.default_value'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.index_code'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.order'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.min_value'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.max_value'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.inline_edit'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.cnc_index'
                                    )
                                }}
                            </th>
                            <th>
                                {{
                                    trans(
                                        'pages.product_type_details.table.hidden'
                                    )
                                }}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <template v-for="(datafield, index) in datafields">
                            <tr :style="getBgColor(index, 0)">
                                <td class="border-top">
                                    &nbsp;
                                    <i
                                        v-if="!productType.externalSystem"
                                        class="fa fa-pencil"
                                        @click="
                                            clickEditField(
                                                datafield.datafieldId
                                            )
                                        "
                                    ></i>
                                    <i
                                        v-if="!productType.externalSystem"
                                        class="fa fa-remove"
                                        @click="clickRemoveField(datafield)"
                                    ></i>
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.datafieldId }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.name }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{
                                        datafield.translations.label[
                                            defaultLanguage
                                        ]
                                    }}
                                    <span
                                        class="tooltip has-saw-condition"
                                        v-if="datafield.hasSawCondition"
                                        @mouseover="
                                            $refs.toolTipCondition[
                                                index
                                            ].showAt($event.target)
                                        "
                                        @mouseout="
                                            $refs.toolTipCondition[
                                                index
                                            ].close()
                                        "
                                    >
                                        !
                                    </span>
                                    <ui5-popover
                                        ref="toolTipCondition"
                                        :allow-target-overlap="false"
                                        placement-type="Bottom"
                                    >
                                        <div>
                                            {{
                                                trans(
                                                    'pages.product_type_details.data_field_warning'
                                                )
                                            }}
                                        </div>
                                    </ui5-popover>
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ outputBool(datafield.mandatory == 1) }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ getDataTypeLabel(datafield) }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ getDefaultValueText(datafield) }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.codeFieldIndex }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.fieldOrder }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.minValue }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.maxValue }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ outputBool(datafield.inlineEdit == 1) }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ datafield.cncIndex }}
                                </td>
                                <td :style="getExtraStyle(datafield)">
                                    {{ outputBool(datafield.hidden == 1) }}
                                </td>
                            </tr>

                            <tr
                                v-if="
                                    datafield.fielddata &&
                                    datafield.fielddata.length > 0
                                "
                            >
                                <td
                                    class="border-top"
                                    :style="getBgColor(index, 0)"
                                >
                                    &nbsp;
                                </td>
                                <td
                                    class="border-left-top"
                                    :style="getBgColor(index, 0)"
                                >
                                    &nbsp;
                                </td>
                                <td
                                    colspan="7"
                                    class="border-top"
                                    :style="getBgColor(index, 1)"
                                >
                                    <div class="inner-table-container">
                                        <table class="inner-table">
                                            <thead>
                                                <tr>
                                                    <th
                                                        class="inner-table-header"
                                                    >
                                                        {{
                                                            trans(
                                                                'pages.product_type_details.inner_table.id'
                                                            )
                                                        }}
                                                    </th>
                                                    <th
                                                        class="inner-table-header"
                                                    >
                                                        {{
                                                            trans(
                                                                'pages.product_type_details.inner_table.key'
                                                            )
                                                        }}
                                                    </th>
                                                    <th
                                                        class="inner-table-header"
                                                    >
                                                        {{
                                                            trans(
                                                                'pages.product_type_details.inner_table.data_option'
                                                            )
                                                        }}
                                                    </th>
                                                    <th
                                                        class="inner-table-header"
                                                    >
                                                        {{
                                                            trans(
                                                                'pages.product_type_details.inner_table.order'
                                                            )
                                                        }}
                                                    </th>
                                                    <th
                                                        class="inner-table-header"
                                                    >
                                                        {{
                                                            trans(
                                                                'pages.product_type_details.inner_table.image'
                                                            )
                                                        }}
                                                    </th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>
                                    <div class="option-table-container">
                                        <table class="option-table">
                                            <tbody>
                                                <tr
                                                    v-for="option in datafield.fielddata"
                                                >
                                                    <td
                                                        :style="
                                                            getOptionExtraStyle(
                                                                option
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            option.datafieldoptionId
                                                        }}
                                                    </td>
                                                    <td
                                                        :style="
                                                            getOptionExtraStyle(
                                                                option
                                                            )
                                                        "
                                                    >
                                                        {{ option.codeId }}
                                                    </td>
                                                    <td
                                                        :style="
                                                            getOptionExtraStyle(
                                                                option
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            option.translations
                                                                .dataoption[
                                                                defaultLanguage
                                                            ]
                                                        }}
                                                    </td>
                                                    <td
                                                        :style="
                                                            getOptionExtraStyle(
                                                                option
                                                            )
                                                        "
                                                    >
                                                        {{ option.order }}
                                                    </td>
                                                    <td
                                                        :style="
                                                            getOptionExtraStyle(
                                                                option
                                                            )
                                                        "
                                                    >
                                                        {{
                                                            option.image &&
                                                            option.image
                                                                .image_path_s3
                                                                ? trans(
                                                                      'pages.product_type_details.yes'
                                                                  )
                                                                : trans(
                                                                      'pages.product_type_details.no'
                                                                  )
                                                        }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </td>
                            </tr>
                        </template>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="rightcolumn">
            <h2>
                {{ trans('pages.product_type_details.help_section.general') }}
            </h2>
            <p
                v-html="
                    trans(
                        'pages.product_type_details.help_section.general_name_field'
                    )
                "
            ></p>
            <p
                v-html="
                    trans(
                        'pages.product_type_details.help_section.general_inactive_fields'
                    )
                "
            ></p>
            <p
                v-html="
                    trans(
                        'pages.product_type_details.help_section.general_null_value'
                    )
                "
            ></p>

            <h2>
                {{ trans('pages.product_type_details.help_section.datatype') }}
            </h2>
            <ul>
                <li>
                    {{
                        trans(
                            'pages.product_type_details.help_section.datatype_boolean'
                        )
                    }}
                </li>
                <li>
                    {{
                        trans(
                            'pages.product_type_details.help_section.datatype_int'
                        )
                    }}
                </li>
                <li>
                    {{
                        trans(
                            'pages.product_type_details.help_section.datatype_string'
                        )
                    }}
                </li>
                <li>
                    {{
                        trans(
                            'pages.product_type_details.help_section.datatype_options'
                        )
                    }}
                </li>
            </ul>

            <h2>
                {{
                    trans('pages.product_type_details.help_section.index_code')
                }}
            </h2>
            <p>
                {{
                    trans(
                        'pages.product_type_details.help_section.index_code_explanation'
                    )
                }}
            </p>

            <h2>
                {{
                    trans(
                        'pages.product_type_details.help_section.data_options'
                    )
                }}
            </h2>
            <p>
                {{
                    trans(
                        'pages.product_type_details.help_section.data_options_code'
                    )
                }}
            </p>
            <p>
                {{
                    trans(
                        'pages.product_type_details.help_section.data_options_inactive'
                    )
                }}
            </p>
            <p
                v-html="
                    trans(
                        'pages.product_type_details.help_section.data_options_explanation'
                    )
                "
            ></p>
        </div>
        <div
            id="popup-edit-datafield-popup-container"
            v-if="showDatafieldPopup"
            @click="closeDatafieldPopup()"
        >
            <div
                id="popup-edit-datafield-popup"
                ref="popupEditDatafield"
                @click="$event.stopPropagation()"
            >
                <div
                    class="spinner-container"
                    v-if="savingDatafield"
                >
                    <spinner />
                </div>
                <div>
                    <ui5-button
                        @click="closeDatafieldPopup()"
                        class="top-button"
                    >
                        {{
                            trans(
                                'pages.product_type_details.datafield_popup.cancel'
                            )
                        }}
                    </ui5-button>
                    <ui5-button
                        @click="saveDatafield()"
                        class="top-button"
                    >
                        {{
                            trans(
                                'pages.product_type_details.datafield_popup.save'
                            )
                        }}
                    </ui5-button>
                </div>
                <div>
                    <div style="clear: both"></div>
                    <datafield-edit-popup
                        :edited-datafield="editedDatafield"
                        :v="$v"
                        :languages="languages"
                        :default-language="defaultLanguage"
                        :data-types="dataTypes"
                        :sub-data-types="subDataTypes"
                        :data-type-options="dataTypeOptions"
                        :is-table-type="isTableType"
                        :create-new-option="createNewOption"
                        :get-type-label="getTypeLabel"
                    ></datafield-edit-popup>
                </div>
                <div>
                    <ui5-button
                        @click="closeDatafieldPopup()"
                        class="top-button"
                    >
                        {{
                            trans(
                                'pages.product_type_details.datafield_popup.cancel'
                            )
                        }}
                    </ui5-button>
                    <ui5-button
                        @click="saveDatafield()"
                        class="top-button"
                    >
                        {{
                            trans(
                                'pages.product_type_details.datafield_popup.save'
                            )
                        }}
                    </ui5-button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ErrorHelper from '../helpers/ErrorHelper';
import TranslationsDisplay from './../components/TranslationsDisplay';
import DatafieldEditPopup from './../components/productTypes/DatafieldEditPopup';
import {
    maxLength,
    minLength,
    numeric,
    required,
    requiredIf,
} from 'vuelidate/lib/validators';
import productTypeApi from '../api/productType';
import supplierApi from '../api/supplier';
import flowApi from '../api/flow';
import workstationApi from '../api/workstation';
import productTypeGroupApi from '../api/productTypeGroup';
import SpinnerText from '../components/loader/SpinnerText';
import Spinner from '../components/loader/Spinner';
import IdParamMixin from '../mixins/id-param';
import IsDebugMixin from '../mixins/is-debug';
import Loader from '../components/loader/Loader';
import OutputHelper from '../helpers/OutputHelper';
import {
    showConfirmDialog,
    showErrorMessage,
    showInfoMessage,
} from '../dialogs';
import _ from 'lodash';
import productAttachmentRules from '../shared/productAttachmentRules';
import localization from '../mixins/localization';
import { getItemPath } from '../shared/nestedStructure';
import { BULK_COPY_REQUIRED_DATAFIELD_KEYS } from '../shared/datafield';

const DATATYPE_OPTIONS = 4;
const DATATYPE_TABLE = 6;

export default {
    mixins: [IdParamMixin(), localization, IsDebugMixin],
    data() {
        return {
            loading: false,
            savingDatafield: false,
            productTypeId: null,
            showDatafieldPopup: false,
            editedDatafield: null,

            productType: null,
            suppliers: null,
            groups: null,
            subgroups: null,
            flowLabels: null,
            datafields: null,
            dataTypes: null,
            subDataTypes: null,
            workstationTypes: null,
            productTypeGroups: null,

            generalInfoItems: null,
            translationTitles: null,
        };
    },
    computed: {
        editedDatafieldPayload() {
            const updateData = { ...this.editedDatafield };
            const typeLabel = this.getTypeLabel(this.editedDatafield);
            const isTableType = this.isTableType(typeLabel);
            if (!isTableType) {
                delete updateData.table;
                delete updateData.tableKey;
                delete updateData.tableField;
                delete updateData.tableFieldName;
                delete updateData.tableField2;
                delete updateData.tableFieldName2;
                delete updateData.tableFilter;
                delete updateData.tableFormat;
            }

            delete updateData.fielddata;
            delete updateData.newOptions;

            if (typeLabel == 'options') {
                const options = [];
                (this.editedDatafield.fielddata || []).forEach((option) => {
                    const fields = { ...option };
                    const removed = fields.remove || false;
                    delete fields.remove;
                    options.push({ fields, removed });
                });

                (this.editedDatafield.newOptions || []).forEach((option) => {
                    const fields = { ...option };
                    const removed = fields.remove || false;
                    delete fields.remove;
                    options.push({ fields, removed });
                });

                updateData.fielddata = options;
            }

            if (typeLabel != 'int') {
                delete updateData.minValue;
                delete updateData.maxValue;
            }

            const productTypeId = this.productTypeId;

            const labelTranslations = updateData.translations.label;
            updateData.label = labelTranslations;
            delete updateData.translations;

            return { updateData, productTypeId };
        },
        dataTypeOptions() {
            if (!this.dataTypes) {
                return [];
            }
            const arr = [];
            Object.entries(this.dataTypes).forEach(([value, label]) => {
                arr.push({ value, label });
            });
            return arr;
        },
        defaultLanguage() {
            if (!this.productType || !this.productType.defaultLanguage) {
                return 'nl-BE';
            }
            return this.productType.defaultLanguage.code;
        },
        languages() {
            return Object.keys(
                this.productType &&
                    this.productType.translations &&
                    this.productType.translations.label
                    ? this.productType.translations.label
                    : {}
            );
        },
        productAttachmentRules: () => productAttachmentRules,
    },
    validations() {
        const isTableType = () => {
            const typeLabel = this.getTypeLabel(this.editedDatafield);
            return this.isTableType(typeLabel);
        };

        return {
            editedDatafield: {
                name: {
                    required: required,
                    maxLength: maxLength(50),
                    minLength: minLength(1),
                },
                mandatory: {
                    required: required,
                },
                defaultValue: {
                    maxLength: maxLength(50),
                },
                prositeInfo: {
                    maxLength: maxLength(65535),
                },
                minValue: {
                    numeric: numeric,
                },
                maxValue: {
                    numeric: numeric,
                },
                fieldOrder: {
                    required: required,
                    numeric: numeric,
                },
                datatype: {
                    validDataType: (value) =>
                        Object.keys(this.dataTypes).includes(String(value)),
                },
                codeFieldIndex: {
                    required: required,
                    numeric: numeric,
                },
                cncIndex: {
                    numeric: numeric,
                },
                hidden: {
                    required: required,
                },
                inUse: {
                    required: required,
                },
                table: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(50),
                },
                tableKey: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(45),
                },
                tableField: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(50),
                },
                tableFieldName: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(50),
                },
                tableField2: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(50),
                },
                tableFieldName2: {
                    required: requiredIf(isTableType),
                    maxLength: maxLength(50),
                },
                tableFilter: {
                    maxLength: maxLength(400),
                },
            },
        };
    },
    methods: {
        getDataTypeLabel(datafield) {
            let text = datafield.datatypeText;
            if (datafield.subDataTypeText) {
                text += ` (${datafield.subDataTypeText})`;
            }
            return text;
        },
        getErrorFromValidator: ErrorHelper.getErrorFromValidator,
        getDefaultValueText(datafield) {
            if (datafield.datatypeText != 'options') {
                return datafield.defaultValue;
            }
            const option = datafield.fielddata.find(
                (x) => x.datafieldoptionId == datafield.defaultValue
            );
            return option &&
                option.translations &&
                option.translations.dataoption
                ? option.translations.dataoption['nl-BE']
                : '"' + datafield.defaultValue + '"';
        },
        load() {
            this.productTypeId = this.idParam;
            this.translationTitles = {
                label: this.trans(
                    'pages.product_type_details.translation_titles.label'
                ),
                productDescription: this.trans(
                    'pages.product_type_details.translation_titles.product_description'
                ),
                prositeDescription: this.trans(
                    'pages.product_type_details.translation_titles.prosite_description'
                ),
                compactDescription: this.trans(
                    'pages.product_type_details.translation_titles.compact_description'
                ),
                quoteDescription: this.trans(
                    'pages.product_type_details.translation_titles.quote_description'
                ),
            };

            this.loading = true;
            this.fetchDependencies(this.productTypeId).then(() => {
                this.loading = false;
                const type = this.productType;
                this.generalInfoItems = [
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.id'
                        ),
                        value: type.producttypeId,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.key'
                        ),
                        value: type.name,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.order'
                        ),
                        value: type.sortBy,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.active'
                        ),
                        value: this.outputBool(type.active),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.show_on_prosite'
                        ),
                        value: this.outputBool(type.showOnProsite),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.auto_process'
                        ),
                        value: this.outputBool(type.autoProcess),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.supplier'
                        ),
                        value: this.getSupplierName(type.supplierId),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.group'
                        ),
                        value: this.getProductTypeGroupName(
                            type.productTypeGroupId
                        ),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.group'
                        ),
                        value: this.getGroupName(type.profilegroup),
                        debugOnly: true,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.subgroup'
                        ),
                        value: this.getSubgroupName(type.profilesubgroup),
                        debugOnly: true,
                    },

                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.code'
                        ),
                        value: type.code ? type.code : '?',
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.default_flow'
                        ),
                        value: this.getFlowLabel(type.defaultFlow),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.order_type'
                        ),
                        value: type.orderType ? type.orderType : '?',
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.cnc_directory'
                        ),
                        value: type.cncDirectory ? type.cncDirectory : '?',
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.initial_state'
                        ),
                        value: type.initialState || '',
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.templates'
                        ),
                        value: this.outputBool(type.allowTemplates),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.is_pleating'
                        ),
                        value: this.outputBool(type.isPleating),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.pleating_overview_info'
                        ),
                        value: this.getDataFieldLabel(
                            type.pleatingOverviewInfo || '?'
                        ),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.pleating_creation_filter'
                        ),
                        value: this.getDataFieldLabel(
                            type.pleatingCreationFilter || '?'
                        ),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.optimize_paintlists'
                        ),
                        value: this.outputBool(type.optimizePaintlists),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.color_required'
                        ),
                        value: this.outputBool(type.colorRequired),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.workstation'
                        ),
                        value: this.getWorkstationTypeName(
                            type.workstationTypeId
                        ),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.immediately_finish'
                        ),
                        value: this.outputBool(type.immediatelyFinish),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.dimensions'
                        ),
                        value: type.dimensions,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.number_of_product_labels'
                        ),
                        value: type.numberOfProductLabels,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.colli'
                        ),
                        value: type.colli,
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.paintlist_as_window'
                        ),
                        value: this.outputBool(type.paintlistAsWindow),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.separate_paintlist'
                        ),
                        value: this.outputBool(type.separatePaintlist),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.allow_color'
                        ),
                        value: this.outputBool(type.allowColor),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.allow_canvas'
                        ),
                        value: this.outputBool(type.allowCanvas),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.allow_count'
                        ),
                        value: this.outputBool(type.allowCount),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.allow_technical_files'
                        ),
                        value: this.outputBool(type.allowTechnicalFiles),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.allow_bulk_copy'
                        ),
                        value: this.outputBool(type.allowBulkCopy),
                    },
                    {
                        label: this.trans(
                            'pages.product_type_details.general_info.attachment_rule'
                        ),
                        value: productAttachmentRules.getLabel(
                            type.attachmentRule
                        ),
                    },
                ];
            });
        },
        createNewOption() {
            const languageData = {};
            this.languages.forEach((x) => {
                languageData[x] = '';
            });
            this.editedDatafield.newOptions = [
                ...this.editedDatafield.newOptions,
                {
                    datafieldoptionId: null,
                    codeId: '',
                    inUse: true,
                    dataoption: this.trans('pages.product_type_details.black'),
                    datafield: this.editedDatafield.datafieldId,
                    description: null,
                    order: 0,
                    cncCodeId: '',
                    paintAreaValue: '',
                    translations: {
                        dataoption: languageData,
                    },
                    remove: false,
                },
            ];
        },
        isTableType(type) {
            return ['table', 'popup', 'multiselect'].includes(type);
        },
        getTypeLabel(field) {
            const typeId =
                field && field.datatype ? parseInt(field.datatype) : 3;
            return this.dataTypes[typeId];
        },
        saveDatafield() {
            this.$refs.popupEditDatafield.scrollTop = 0;
            this.savingDatafield = true;
            const components = [this, ...Object.values(this.$refs).flat()];

            components.forEach((x) => {
                if (x.$v) {
                    x.$v.$touch();
                }
            });

            let valid = true;
            components.forEach((x) => {
                if (x.$v && x.$v.$invalid) {
                    valid = false;
                    if (x.$v.editedDatafield) {
                        const invalidField = _.findKey(
                            x.$v.editedDatafield.$params,
                            (value, key) => x.$v.editedDatafield[key].$invalid
                        );
                    }
                }
            });

            if (!valid) {
                showErrorMessage(
                    this.trans(
                        'pages.product_type_details.messages.resolve_input_errors'
                    )
                );
                this.savingDatafield = false;
                return;
            }

            const imagePromises = [];

            // Get deleted images from datafield options
            const filesToDelete = (
                this.editedDatafieldPayload?.updateData?.fielddata || []
            )
                .filter(
                    (option) =>
                        option.fields.image && option.fields.image.removed
                )
                .map((option) => option.fields.image.image_path_s3);

            if (filesToDelete.length > 0) {
                imagePromises.push(
                    productTypeApi.deleteMultipleDataFieldOptionImages(
                        filesToDelete
                    )
                );
            }

            // Get new images from datafield options
            (this.editedDatafieldPayload?.updateData?.fielddata || []).forEach(
                (option) => {
                    if (option.fields.image && option.fields.image.added) {
                        imagePromises.push(
                            productTypeApi
                                .uploadDataFieldOptionImage(
                                    option.fields.image.file
                                )
                                .then((response) => {
                                    option.fields.image.image_path_s3 =
                                        response.data.fileName;
                                })
                                .finally(() => {
                                    delete option.fields.image.file;
                                    delete option.fields.image.url;
                                })
                        );
                    }
                }
            );

            // Run all image promises
            Promise.all(imagePromises)
                .then(() => {
                    return this.editedDatafieldPayload.updateData.datafieldId
                        ? productTypeApi.updateDatafield(
                              this.editedDatafieldPayload
                          )
                        : productTypeApi.newDatafield(
                              this.editedDatafieldPayload
                          );
                })
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.product_type_details.messages.changes_saved'
                        )
                    );

                    this.$router.go();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'pages.product_type_details.messages.error_prefix'
                        ) + ErrorHelper.parseError(error.response.data)
                    );
                })
                .finally(() => {
                    this.savingDatafield = false;
                });
        },
        closeDatafieldPopup() {
            this.showDatafieldPopup = false;
            this.editedDatafield = null;
        },
        clickRemoveField(datafield) {
            // The server refuses this as well, this just skips the pointless confirmation
            if (
                this.productType.allowBulkCopy &&
                BULK_COPY_REQUIRED_DATAFIELD_KEYS.includes(datafield.name)
            ) {
                return showErrorMessage(
                    this.trans('product_types.datafield_required_for_bulk_copy')
                );
            }

            const extraWarning = datafield.hasSawCondition
                ? this.trans(
                      'pages.product_type_details.datafield.saw_condition_warning'
                  )
                : '';
            showConfirmDialog({
                title: this.trans(
                    'pages.product_type_details.datafield.remove_title'
                ),
                content:
                    this.trans(
                        'pages.product_type_details.datafield.remove_confirm'
                    ) + extraWarning,
                html: true,
                confirm: (dialog) => {
                    dialog.close();
                    showInfoMessage(
                        this.trans(
                            'pages.product_type_details.datafield.removing'
                        )
                    );

                    productTypeApi
                        .removeDataField(datafield.datafieldId)
                        .then(() => {
                            this.$router.go();
                        })
                        .catch((error) => {
                            showErrorMessage(
                                this.trans(
                                    'pages.product_type_details.messages.error_prefix'
                                ) + ErrorHelper.parseError(error.response.data)
                            );
                        });
                },
                cancel(dialog) {
                    dialog.close();
                },
                confirmButton: this.trans(
                    'pages.product_type_details.datafield.remove_button'
                ),
                cancelButton: this.trans(
                    'pages.product_type_details.datafield.cancel_button'
                ),
            });
        },
        fetchDependencies(productTypeId) {
            const suppliersPromise = supplierApi
                .fetchAllSuppliers()
                .then((response) => {
                    this.suppliers = response.data.data;
                });

            const groupsDataPromise = productTypeApi
                .listSubgroups()
                .then((response) => {
                    this.groups = response.data.data;
                });

            const supGroupsPromise = productTypeApi
                .listSubgroups()
                .then((response) => {
                    this.subgroups = response.data.data;
                });

            const fetchFlowsPromise = flowApi
                .fetchAllFlows()
                .then((response) => {
                    this.flowLabels = [];
                    response.data.data.forEach((x) => {
                        this.flowLabels[x.flowId] = x.label;
                    });
                });

            const dataTypesPromise = productTypeApi
                .getDataTypes()
                .then((response) => {
                    this.dataTypes = response.data.data.types;
                    this.subDataTypes = response.data.data.subTypes;
                });

            const datafieldsPromise = productTypeApi
                .fetchDataFields(productTypeId)
                .then((response) => {
                    this.datafields = response.data.data;
                });

            const workstationTypesPromise = workstationApi
                .fetchAllTypes(null, false)
                .then((response) => {
                    this.workstationTypes = response.data.data;
                });

            const productTypePromise = productTypeApi
                .fetchForEdit(productTypeId)
                .then((response) => {
                    const productType = response.data.data;
                    this.productType = productType;
                    const translations = productType.translations;
                    const defaultCode = productType.defaultLanguage.code;
                    this.$store.commit(
                        'general/setPageTitle',
                        this.trans(
                            'pages.product_type_details.messages.details_prefix'
                        ) + translations['label'][defaultCode],
                        { root: true }
                    );
                });

            const productTypeGroupsPromise = productTypeGroupApi
                .list()
                .then((response) => {
                    this.productTypeGroups = response.data;
                });

            const promises = [
                dataTypesPromise,
                suppliersPromise,
                fetchFlowsPromise,
                groupsDataPromise,
                supGroupsPromise,
                datafieldsPromise,
                workstationTypesPromise,
                productTypePromise,
                productTypeGroupsPromise,
            ];

            return Promise.all(promises);
        },
        outputBool(b) {
            return OutputHelper.boolToYesNo(
                b,
                OutputHelper.capitalization.allCaps
            );
        },
        getBgColor(index, i) {
            var colors =
                index % 2 == 0
                    ? ['#CCCCCC', '#FFFFFF']
                    : ['#FFFFFF', '#CCCCCC'];
            return { 'background-color': colors[i] };
        },
        getOptionExtraStyle(item) {
            var style = {
                width: '25%',
                'text-align': 'right',
            };

            if (item.inUse != 1) {
                style['text-decoration'] = 'line-through';
            }
            return style;
        },
        getExtraStyle(item) {
            var style = {
                'border-top': 'solid 1px',
                'border-left': 'solid 1px',
            };

            if (item.inUse != 1) {
                style['text-decoration'] = 'line-through';
            }
            return style;
        },
        clickNewField() {
            const languageData = {};
            this.languages.forEach((x) => {
                languageData[x] = '';
            });

            const productTypeId = this.productTypeId;

            let datatype = null;
            let datatypeText = null;
            Object.entries(this.dataTypes).forEach(([value, label]) => {
                if (label == 'string') {
                    datatype = value;
                    datatypeText = label;
                }
            });

            this.editedDatafield = {
                datafieldId: null,
                fieldvalue: null,
                name: '',
                label: '',
                fieldsgroup: null,
                fieldOrder: '',
                defaultValue: null,
                minValue: null,
                maxValue: null,
                datatype: datatype,
                datatypeText: datatypeText,
                mandatory: false,
                table: null,
                tableKey: null,
                tableField: null,
                tableFieldName: null,
                tableField2: null,
                tableFieldName2: null,
                tableFormat: null,
                skipInitialValidation: false,
                tableFilter: null,
                fielddata: [],
                newOptions: [],
                fieldvaluedescription: null,
                inlineEdit: false,
                cncIndex: null,
                hidden: false,
                hasSawCondition: null,
                onProdForm: null,
                emphOnProdForm: '',
                prodFormGroup: '',
                prodFormOrder: '',
                producttype: productTypeId,
                codeFieldIndex: '',
                inUse: true,
                useAbsoluteValue: false,
                translations: {
                    label: {
                        ...languageData,
                    },
                    info1: {
                        ...languageData,
                    },
                    info2: {
                        ...languageData,
                    },
                },
            };
            this.showDatafieldPopup = true;
        },
        clickEditField(id) {
            this.showDatafieldPopup = true;

            productTypeApi
                .fethDataFieldForEdit(id)
                .then((request) => {
                    const datafield = request.data.data;
                    datafield.newOptions = [];
                    if (datafield.codeFieldIndex === undefined) {
                        datafield.codeFieldIndex = null;
                    }
                    if (datafield.fielddata) {
                        datafield.fielddata.forEach((x) => {
                            x.remove = false;
                        });
                    }
                    this.editedDatafield = datafield;
                    this.$v.$reset();
                })
                .catch((error) => {
                    showErrorMessage(
                        this.trans(
                            'pages.product_type_details.messages.error_prefix'
                        ) + ErrorHelper.parseError(error.response.data)
                    );
                });
        },
        editProductType() {
            this.$router.push('/editProducttype/' + this.productTypeId);
        },
        backToList() {
            this.productType = null;
            this.generalInfoItems = null;
            this.translationTitles = null;
            this.$router.push('/settingsProducttypes');
        },
        getSupplierName(id) {
            if (id == null) {
                return '?';
            }

            for (var i = 0, iLen = this.suppliers.length; i < iLen; i++) {
                var supplier = this.suppliers[i];

                if (supplier.id == id) {
                    return supplier.name;
                }
            }

            return '?';
        },
        getProductTypeGroupName(id) {
            if (id == null) {
                return '?';
            }

            for (
                var i = 0, iLen = this.productTypeGroups.length;
                i < iLen;
                i++
            ) {
                var group = this.productTypeGroups[i];

                if (group.id == id) {
                    return getItemPath(
                        group.id,
                        this.productTypeGroups,
                        this.isDebug
                    );
                }
            }

            return '?';
        },
        getGroupName(id) {
            if (id == null) {
                return '?';
            }

            for (var i = 0, iLen = this.groups.length; i < iLen; i++) {
                var group = this.groups[i];

                if (group.id == id) {
                    return group.name;
                }
            }

            return '?';
        },
        getSubgroupName(id) {
            if (id == null) {
                return '?';
            }

            for (var i = 0, iLen = this.subgroups.length; i < iLen; i++) {
                var group = this.subgroups[i];

                if (group.id == id) {
                    return group.name;
                }
            }

            return '?';
        },
        getFlowLabel(flowId) {
            return this.flowLabels[flowId] || '?';
        },
        getWorkstationTypeName(id) {
            if (id == null) {
                return '?';
            }

            const count = this.workstationTypes.length;

            for (var i = 0; i < count; i++) {
                var workstationType = this.workstationTypes[i];

                if (workstationType.id == id) {
                    return workstationType.externalName;
                }
            }
            return '?';
        },
        getDataFieldLabel(id) {
            let result = '';
            let field = this.datafields.find((x) => x.datafieldId == id);
            return field ? field.name + ' (#' + field.datafieldId + ')' : '';
        },
    },
    components: {
        Loader,
        SpinnerText,
        Spinner,
        'translations-display': TranslationsDisplay,
        'datafield-edit-popup': DatafieldEditPopup,
    },
};
</script>
